import { trpc } from '@/shared/api';

/** HOME 기업 고객 사례 목록(어드민) — 노출 순서대로. */
export const useLandingTestimonialsQuery = () => trpc.landing.listTestimonialsAdmin.useQuery();
